import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Menu,
  MenuItem,
  Button,
  Tabs,
  Tab,
  TextField,
  Breadcrumbs,
} from "@mui/material";
import LK_Filter from "../../images/LK_Filter";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../../cssfiles/homepage.css";
import { useSelector } from "react-redux";
import { getAuditLogs } from "../../Restclient/datacollection";
import { Table } from "antd";
import dayjs from "dayjs";
import Overviewbar from "../Overviewbar";
import AuditLeftPane from "./AuditLeftPane";
import Year from "../CommonComponents/Year";
import Searchall from "../CommonComponents/Search";

const convertToIST = (epochts) => {
  const date = new Date(epochts * 1000);
  return date.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour12: false,
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

function Auditlog() {
  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates_dashboard
  );

  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const themechange = useSelector((state) => state.themedata.theme);
  const [value, setValue] = useState("User Logs");
  const tablist = ["User Logs", "Login Activity"];
  const [searchText, setSearchText] = useState("");
  const [timeFilter, setTimeFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([
    "Timestamp",
    "Process Name",
    "Action",
    "New Value",
    "Comment",
  ]);
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const userid = useSelector((state) => state.logindata.username);

  const logtype =
    value === "User Logs"
      ? "USER"
      : value === "System Logs"
      ? "SYSTEM"
      : value === "Login Activity"
      ? "LOGIN"
      : "NA";
  const [auditLogData, setAuditLogData] = useState([]);

  const handletabchange = (event, newValue) => {
    setValue(newValue);
  };
  const handleSearch = (e) => {
    const text = e.target.value.toLowerCase();
    setSearchText(text);
    applyFilters(text, timeFilter);
  };
  const handleTimeFilterChange = (event) => {
    const filter = event.target.value;
    setTimeFilter(filter);
    applyFilters(searchText, filter);
  };
  const applyFilters = (searchText, timeFilter) => {
    let filtered = auditLogData;

    // Apply search filter
    if (searchText) {
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchText)
        )
      );
    }

    // Apply timestamp filter
    if (timeFilter) {
      const now = dayjs();
      filtered = filtered.filter((item) => {
        const recordDate = dayjs(item.timestamp * 1000);
        if (timeFilter === "24h")
          return recordDate.isAfter(now.subtract(1, "day"));
        if (timeFilter === "7d")
          return recordDate.isAfter(now.subtract(7, "day"));
        if (timeFilter === "30d")
          return recordDate.isAfter(now.subtract(30, "day"));
        return true;
      });
    }

    setFilteredData(filtered);
  };

  const formatNewValue = (value) => {
    try {
      const data = JSON.parse(value);

      let str = "";
      for (let key in data) {
        str += key + " = " + data[key] + ", ";
      }
      let str_new = str.substring(0, str.length - 2);

      return str_new;
    } catch (error) {
      return "NULL";
    }
  };

  const formatOldValue = (value) => {
    try {
      const data = JSON.parse(value);

      let str = "";
      for (let key in data) {
        str += key + " = " + data[key] + ", ";
      }
      let str_new = str.substring(0, str.length - 2);

      return str_new;
    } catch (error) {
      return "NULL";
    }
  };
  const [pagesize, setPagesize] = useState(353); /*  */

  const Systemcolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      render: (timestamp) => convertToIST(timestamp),
      sorter: (a, b) => a.timestamp - b.timestamp,
    },
    {
      title: "Process Name",
      dataIndex: "process",
    },
    {
      title: "Action",
      dataIndex: "action",
    },
    {
      title: "Old Value",
      dataIndex: "old_value",
      render: (old_value) => formatOldValue(old_value),
    },
    {
      title: "New Value",
      dataIndex: "new_value",
      render: (new_value) => formatNewValue(new_value),
    },
    {
      title: "Comment",
      dataIndex: "comment",
    },
  ];
  const Usercolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      render: (timestamp) => convertToIST(timestamp),
      sorter: (a, b) => a.timestamp - b.timestamp,
    },
    {
      title: "Process Name",
      dataIndex: "process",
    },
    {
      title: "Action",
      dataIndex: "action",
    },
    {
      title: "Old Value",
      dataIndex: "old_value",
      render: (old_value) => formatOldValue(old_value),
    },
    {
      title: "New Value",
      dataIndex: "new_value",
      render: (new_value) => formatNewValue(new_value),
    },
    {
      title: "Comment",
      dataIndex: "comment",
    },
  ];
  const Logincolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      render: (timestamp) => convertToIST(timestamp),
      sorter: (a, b) => a.timestamp - b.timestamp,
    },
    {
      title: "Process Name",
      dataIndex: "process",
    },
    {
      title: "Action",
      dataIndex: "action",
    },
    {
      title: "Comment",
      dataIndex: "comment",
    },
  ];
  const [pathselected, setPathselected] = useState([
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Plant
    </Typography>,
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Dashboard
    </Typography>,
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Audit Logs
    </Typography>,
  ]);
  const callback = (res) => {
    setAuditLogData(res.data);
    setFilteredData(res.data);
  };
  // Filter Usercolumns dynamically based on selectedColumns
  const filteredUserColumns = Usercolumns.filter((col) =>
    selectedColumns.includes(col.title)
  );

  useEffect(() => {
    if (overviewstate) {
      setPagesize(293);
    } else {
      setPagesize(258);
    }
  }, [overviewstate]);

  useEffect(() => {
    getAuditLogs(
      logtype,
      userid,
      projectId,
      callback,
      sdate_edate_selected.startdates.toString(),
      sdate_edate_selected.enddates.toString()
    );
  }, [value, sdate_edate_selected]);
  return (
    <Box className="Audit-Module" sx={{}}>
      <Overviewbar />
      <div
        style={{ display: "flex", flexDirection: "row", marginRight: "18px" }}
      >
        <div
          className="breadcrumb-reporting"
          style={{ flexGrow: 1, marginRight: "4px", marginLeft: "16px" }}
        >
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{ color: "var(--GreyVariation_2)" }}
              />
            }
            style={{ padding: "10px 12px 10px 12px", textAlign: "center" }}
          >
            {pathselected}
          </Breadcrumbs>
        </div>
        <TextField
          required
          className="textfield"
          placeholder="Search..."
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            marginRight: "4px",
            backgroundColor: "var(--SecondaryBackground)",
            justifyContent: "center",
            paddingLeft: "4px",
            "& .MuiInputBase-input:focus": {
              color: "#008CD7",
            },
            "& .MuiInputBase-root": {
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "400",
              color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
            },
            "& .MuiInput-root .MuiInputBase-input": {},
            "& .MuiInputBase-root::before": {
              borderBottom: `0px solid ${
                themechange === "light" ? "#3C3C3C" : "#FFFFFF"
              }`,
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottom: "0px solid #008CD7",
            },
            "& .MuiInputBase-root::after": {
              borderBottom: "0px solid #008CD7",
            },
          }}
          label=""
          value={searchText}
          onChange={handleSearch}
          variant="standard"
        />
        <Year />
      </div>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          padding: "0px 16px",
          boxSizing: "border-box",
          marginTop: "16px",
        }}
      >
        <AuditLeftPane
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          selectedTab={value}
        />
        <Box
          style={{
            width: "100%",
            boxSizing: "border-box",
            height: "93%",
            backgroundColor: "var(--PrimaryBackground)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Tabs
              value={value}
              onChange={handletabchange}
              TabIndicatorProps={{ hidden: true }}
              sx={{
                "& .MuiTabs-indicator": {
                  display: "none",
                  height: "0px",
                  borderRadius: "0px",
                  backgroundColor: "var(--action-button-light)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                "& .Mui-selected": {
                  color: "var(--LK_BrandBlue_1) !important",
                  fontWeight: "700 !important",
                  backgroundColor: "var(--PrimaryBackground)",
                  borderTop: "1px solid var(--HighlightedText_Stroke)",
                  borderLeft: "1px solid var(--HighlightedText_Stroke)",
                  borderRight: "1px solid var(--HighlightedText_Stroke)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                "& .MuiTab-root": {
                  padding: "8px 8px 6px 8px !important",
                  margin: "0px !important",
                  minWidth: "63px",
                },
                minHeight: "30px",
                marginBottom: "-1px",
              }}
            >
              {tablist.map((tab) => {
                return (
                  <Tab
                    sx={{
                      minHeight: "30px",
                      height: "30px",
                    }}
                    style={{
                      color: "var(--GreyVariation_2)",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "16.75px",
                      textTransform: "capitalize",
                    }}
                    value={tab}
                    label={tab}
                  >
                    {tab}
                  </Tab>
                );
              })}
            </Tabs>
          </div>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: "var(--SecondaryBackground))",
              padding: "8px",
              width: "100%",
              height: `calc(100vh - ${pagesize}px)`,
              overflow: "auto",
              boxSizing: "border-box",
              border: "1px solid var(--HighlightedText_Stroke)",
              overflow: "auto",
            }}
          >
            <Table
              columns={
                value === "User Logs"
                  ? filteredUserColumns
                  : value === "System Logs"
                  ? Systemcolumns
                  : value === "Login Activity"
                  ? Logincolumns
                  : []
              }
              dataSource={filteredData}
              pagination={false}
              className="anttable"
              locale={{
                emptyText: (
                  <span style={{ color: "var(--GreyBaseColor)" }}>
                    {" "}
                    No match found
                  </span>
                ),
              }}
              style={{
                width: "100%",
                colorBgContainer: "var(--primary-backgroundLK)",
              }}
              showSorterTooltip={false}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );

  // Further please add user id wise access to logs.
}

export default Auditlog;
